import { useCallback, useEffect, useMemo, useState } from 'react';
import { obtenerProductos } from '../services/productosService';
import { getNegocioId } from '../services/negocioActual';
import { ajusteStockPendiente } from '../services/ventasPendientes';
import { mensajeAmigable } from '../utils/errores';

// Maneja la carga del inventario con estados de carga y error.
// `publico`: catálogo para clientas (vista sin datos privados).
export function useProductos({ publico = false } = {}) {
  const [base, setProductos] = useState([]);
  const [versionPendientes, setVersionPendientes] = useState(0);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(null);

  const recargar = useCallback(async () => {
    setCargando(true);
    setError(null);
    try {
      setProductos(await obtenerProductos({ publico }));
    } catch (e) {
      setError(mensajeAmigable(e));
    } finally {
      setCargando(false);
    }
  }, [publico]);

  useEffect(() => {
    recargar();
  }, [recargar]);

  // Ventas hechas sin internet que aún no se suben: se restan del stock para
  // que el inventario y el punto de venta muestren lo que realmente queda.
  useEffect(() => {
    const cambio = () => setVersionPendientes((v) => v + 1);
    window.addEventListener('kontrol-pendientes', cambio);
    return () => window.removeEventListener('kontrol-pendientes', cambio);
  }, []);
  const productos = useMemo(() => {
    if (publico) return base;
    let ajuste = {};
    try { ajuste = ajusteStockPendiente(getNegocioId()); } catch { /* sin negocio */ }
    if (!Object.keys(ajuste).length) return base;
    return base.map((p) => (ajuste[p.id] ? { ...p, stock: Math.round((Number(p.stock || 0) - ajuste[p.id]) * 1000) / 1000 } : p));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [base, publico, versionPendientes]);

  return { productos, cargando, error, recargar };
}
